const AVAILABLE_LOCALES = ['en-gb', 'de-de']

export const isExperimentAvailable = (locale: string) => AVAILABLE_LOCALES.includes(locale?.toLowerCase())

export const shouldShowExp = (variation: string | null) => !!variation && variation === 'test'

export const getExperimentByLocale = (locale: string) => {
  const localeLower = locale?.toLowerCase()
  if (localeLower === 'en-gb' || localeLower === 'de-de') return 'hc_whatsapp_experiment_uk_de'
  return ''
}
